<template>
  <x-page title="售后管理" :loading="loading">
    <template v-if="!loading">
      <div :class="_.conteinar">
        <x-waterfall :load="handleLoad">
          <template #default="{ data }">
            <orderItem
              v-for="(orderInfo, index) in data"
              :key="index"
              :order-state="activeTabNum - 1"
              :order="orderInfo"
            ></orderItem>
          </template>
        </x-waterfall>
      </div>
    </template>
  </x-page>
</template>

<script>
  import orderItem from './orderdelivery/orderItem.vue'
  import Vue from 'vue'
  import { apiOrderMerchantOrderList } from '@/api'
  import { Track } from '@/utils/Track'

  export default Vue.extend({
    components: { orderItem },
    mixins: [
      Track.provideMark(() => ({
        page: '售后管理',
      })),
    ],

    computed: {
      loading() {
        return false
      },
    },
    methods: {
      handleLoad({ pageNumber }) {
        return apiOrderMerchantOrderList(
          {
            pageIndex: pageNumber,
            pageSize: 10,
            status: 10,
          },
          { hasStoreCode: true },
        )
      },
    },
  })
</script>

<style lang="scss" module>
  .conteinar {
    padding: 0 12px;
  }
</style>
